<template>
  <!-- 财务审核 -->
  <div class="billOperationRecord public_Spacing performance-records-page">
    <div class="pulbic_oparetionBlock performance-filter-panel" style="margin-bottom: 12px;">
      <div class="performance-filter-head">
        <div>
          <div class="performance-filter-title">筛选条件</div>
          <div class="performance-filter-subtitle">按客户、提现类型、手机号和到账时间筛选记录</div>
        </div>
        <div class="performance-filter-range">{{ date[0] || '--' }} 至 {{ date[1] || '--' }}</div>
      </div>
      <div class="performance-filter-body">
        <div class="public_criteriaRange performance-filter-controls">
          <div class="public_oparetionBlock_Menu performance-filter-item">
            <label class="public_lbSty">客户：</label>
            <el-select
              class="public_optionSty dropDown_Define"
              v-model="customerMo"
              placeholder="请选择"
              :clearable="true"
              filterable
            >
              <el-option
                v-for="(item, index) in customerOptions"
                :key="index"
                :label="item.ORMTB421CA06"
                :value="item.ORMTB421CA08"
              >
              </el-option>
            </el-select>
          </div>
          <div class="public_oparetionBlock_Menu performance-filter-item">
            <label class="public_lbSty">提现类型：</label>
            <el-select
              class="public_optionSty dropDown_Define"
              v-model="txlx"
              placeholder="请选择"
              :clearable="true"
              filterable
            >
              <el-option
                v-for="item in materielOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="performance-phone-filter">
            <label class="public_lbSty">手机号:</label>
            <el-input
              v-model="ORMTB429CA10"
              placeholder="请输入手机号查询"
              class="performance-phone-input"
            ></el-input>
          </div>
        </div>
        <div class="public_operatArea performance-time-controls">
          <span
            class="pulic_operatArea_now pulic_cursor"
            :class="dateNowDayActive ? 'public_dateActive' : ''"
            @click="getNowDay"
            >当日</span
          >
          <span
            class="public_operatArea_yesterday pulic_cursor"
            :class="dateYesterdayActive ? 'public_dateActive' : ''"
            @click="getYesterday"
            >昨天</span
          >
          <span
            class="pulic_operatArea_now pulic_cursor"
            :class="dateNowMonthActive ? 'public_dateActive' : ''"
            @click="sameMonth"
            >当月</span
          >
          <span
            class="public_operatArea_yesterday pulic_cursor"
            :class="dateLastMonthActive ? 'public_dateActive' : ''"
            @click="lastMonth"
            >上月</span
          >
          <div class="public_operatArea_timePicker pulic_cursor">
            <el-date-picker
              v-model="date"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              :picker-options="startDateDisabled"
              @change="datePickerChange"
              start-placeholder="开始日"
              end-placeholder="结束日"
              class="pulic_cursor performance-date-picker"
            >
            </el-date-picker>
          </div>
          <div class="public_operatBtn performance-action-controls">
            <el-button type="primary" @click="queryClick"
              ><i class="iconfont icon-chaxun"></i>查询</el-button
            >
            <el-button type="success" @click="exports"
              ><i class="iconfont icon-daochu"></i>导出</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="billOperationRecord-table pulbic_table_container performance-table-card">
      <div class="performance-table-head">
        <div>
          <div class="performance-table-title">到账流水</div>
          <div class="performance-table-subtitle">共 {{ pagingPageMo || 0 }} 条记录，当前页 {{ tableData.length }} 条</div>
        </div>
        <div class="performance-total-card">
          <span>总金额</span>
          <strong>{{ zjr || 0 }}</strong>
          <em>元</em>
        </div>
      </div>
      <el-table
        tooltip-effect="dark"
        :data="tableData"
        style="width: 100%;"
        max-height="90%"
        :default-sort="{ prop: 'waterNum', order: 'descending' }"
        :header-cell-style="{
          color: 'rgba(51,51,51,1)',
          'font-weight': 'bold',
        }"
        class="public_tableColumn performance-main-table"
      >
        <el-table-column prop="ORMTB410CA00" label="客户名称">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.ORMTB431CA03 }}</span>
            </p>
            <p style="color: #999;">
              <span>{{ scope.row.ORMTB431CA05 }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="提现类型">
          <template slot-scope="scoped">
            {{
              scoped.row.ORMTB431CA00 === 'YFTX'
                ? '运费提现'
                : scoped.row.ORMTB431CA00 === 'YETX'
                ? '余额提现'
                : scoped.row.ORMTB431CA00 === 'HK'
                ? '回款'
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="ORMTB431CA01" label="金额"> </el-table-column>
        <el-table-column prop="ORMTB431CA02" label="到账时间">
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="DetailsClick(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pulbic_pagesize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limitMo"
          layout="total,sizes, prev, pager, next, jumper"
          :total="pagingPageMo"
        >
        </el-pagination>
      </div>
    </div>
    <div class="public-dialog">
      <el-dialog
        title="提现详情"
        :visible.sync="oerderDetilsShow"
        width="45%"
        @close="detailsList = ''"
        :closeOnClickModal="false"
       append-to-body custom-class="performance-records-dialog">
        <div class="tx-detail-panel">
          <div class="tx-detail-grid">
            <div class="tx-detail-item">
              <div class="tx-detail-label">客户名称</div>
              <div class="tx-detail-value">{{ detailObj.ORMTB431CA03 || '--' }}</div>
            </div>
            <div class="tx-detail-item">
              <div class="tx-detail-label">提现类型</div>
              <div class="tx-detail-value">
                {{
                  detailObj.ORMTB431CA00 == 'YFTX'
                    ? '运费提现'
                    : detailObj.ORMTB431CA00 === 'YETX'
                    ? '余额提现'
                    : detailObj.ORMTB431CA00 === 'HK'
                    ? '回款'
                    : '--'
                }}
              </div>
            </div>
            <div class="tx-detail-item tx-detail-item--full tx-detail-item--amount">
              <div class="tx-detail-label">实际到账总额</div>
              <div class="tx-detail-value tx-detail-value--amount">{{ detailObj.ORMTB431CA01 || '--' }}</div>
            </div>
            <div class="tx-detail-item">
              <div class="tx-detail-label">原路退回金额</div>
              <div class="tx-detail-value">{{ detailObj.ORMTB431CA06 || '--' }}</div>
            </div>
            <div class="tx-detail-item">
              <div class="tx-detail-label">银行卡到账金额</div>
              <div class="tx-detail-value">{{ detailObj.ORMTB431CA07 || '--' }}</div>
            </div>
            <div class="tx-detail-item">
              <div class="tx-detail-label">账号</div>
              <div class="tx-detail-value">{{ detailObj.ORMTB431CA08 || '--' }}</div>
            </div>
            <div class="tx-detail-item">
              <div class="tx-detail-label">到账时间</div>
              <div class="tx-detail-value">{{ detailObj.ORMTB431CA02 || '--' }}</div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import customerSearchMixin from '@/mixins/customerSearchMixin'
export default {
  mixins: [customerSearchMixin],
  name: 'PerformanceRecords',
  data() {
    return {
      isorderAuditText: '',
      sjtxje: '',
      sjtxjenotes: '',
      ORMTB421ID: '',
      txlx: '',
      ORMTB429CA10: '',
      oerderDetilsShow: false,
      isorderAuditShow: false,
      uobj: this.$store.state.uobj, //登陆缓存--用户信息
      date: [], //日期
      dateNowDayActive: false,
      dateYesterdayActive: false,
      dateNowMonthActive: false,
      dateLastMonthActive: false,
      tableData: [],
      materialOptions: [],
      materialTypeValue: '',
      customerOptions: [],
      carNum: '',
      materielMo: '',
      materielOptions: [
        {
          value: 'YFTX',
          label: '运费提现',
        },
        {
          value: 'YETX',
          label: '余额提现',
        },
        {
          value: 'HK',
          label: '回款',
        },
      ],
      zjr: 0,
      // 查询
      customerMo: '', //客户--查询
      ORMTB421CA14: '', //数据状态
      billOperationAdd: false,
      pageMo: 1, //默认列表页码
      limitMo: 10, //每页的条数
      pagingPageMo: 0, //分页--数据列表共有的条数
      currentPage: 1, //设置当前页默认为1
      tableHeadList: [
        {
          prop: 'ORMTB421CA00',
          label: '申请类型',
        },
        {
          prop: 'ORMTB421CA02',
          label: '金额',
        },
        {
          prop: 'ORMTB421CA98',
          label: '可提现金额',
        },

        {
          prop: 'ORMTB421CA14',
          label: '审核状态',
        },
        {
          prop: 'ORMTB421CA16',
          label: '审核时间',
        },
        {
          prop: 'ORMTB421CA17',
          label: '审核人',
        },
      ],
      // 审核
      imageUrl: '',
      // 详情
      billOperationDetails: false,
      detailsList: '', //详情列表
      isRefresh: true,
      isRefreshSetInterval: '',
      // quanpDisabled: false,
      // 历史缓存
      currentUrl: this.$route.path,
      historyInfo: '',
      // 时间限制
      // 限制开始日期不能超过当前日期
      startDateDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      solelist: [],
      DetailsWaterurl: '',
      DetailsWatersrcList: [],
      detailObj: {},
    }
  },
  created() {
    var list = ''
    list = this.$store.state.solelist
    // 赋值，缓存销毁
    this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
    sessionStorage.removeItem(this.currentUrl)
    if (this.historyInfo != null && this.historyInfo != '') {
      this.init()
    } else {
      this.getNowDay()
    }
    var path = this.$route.path
    if (path === '/SalesDispatchManagement') {
      path = '/Home' + path
    }
    this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
  },
  mounted() {
    this.enterprise0ptions()
    this.pageList()
  },
  // 存储数据
  beforeDestroy() {
    var obj = {
      startTime: [this.date[0], this.date[1]], //开始时间
      customerMo: this.customerMo, //申请人
      materielMo: this.materielMo, //申请类型
      ORMTB421CA14: this.ORMTB421CA14, //审核状态
      currentPage: this.currentPage, //当前页数
      pageMo: this.pageMo, //页码
      limitMo: this.limitMo, //每页条数
      dateNowDayActive: this.dateNowDayActive,
      dateYesterdayActive: this.dateYesterdayActive,
      dateNowMonthActive: this.dateNowMonthActive,
      dateLastMonthActive: this.dateLastMonthActive,
    }
    sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
  },
  methods: {
    //初始化数据
    init() {
      this.date = this.historyInfo.startTime
      this.customerMo = this.historyInfo.customerMo
      this.materielMo = this.historyInfo.materielMo
      this.ORMTB421CA14 = this.historyInfo.ORMTB421CA14
      this.currentPage = this.historyInfo.currentPage
      this.pageMo = this.historyInfo.pageMo
      this.limitMo = this.historyInfo.limitMo
      this.dateNowDayActive = this.historyInfo.dateNowDayActive
      this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
      this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
      this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
    },
    // 上传图片
    handleChangeAdd(file, image) {
      this.imageUrl = image
      // console.log(this.imageUrl)
    },
    // 导出
    exports() {
      var startTime = this.date[0] //开始时间
      var endTime = this.date[1] //结束时间
      var ORMTB429CA10 = this.ORMTB429CA10 //手机号
      var ORMTB410ID = this.customerMo //客户
      var TXLX = this.txlx

      var url =
        this.axios.defaults.baseURL +
        '/exc/toExcel/ormtb431toExcle?startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&ORMTB429CA10=' +
        ORMTB429CA10 +
        '&ORMTB410ID=' +
        ORMTB410ID +
        '&TXLX=' +
        TXLX
      window.location.href = url
    },
    // 申请人--查询
    enterprise0ptions() {
      var List = [
        {
          ORMTB421CA08: '',
          ORMTB421CA06: '全部',
        },
      ]
      var url = '/orm/ormtb421/selectOrmtb421CA06List'
      this.axios.post(url).then(res => {
        // console.log(res)
        if (res.data.code == 200) {
          this.customerOptions = [...List, ...res.data.data]
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    // 查询
    queryClick() {
      this.pageList()
    },
    // 列表
    pageList() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      console.log(this.date)

      const postData = {
        ORMTB410ID: this.customerMo, //申请人ID
        ORMTB429CA10: this.ORMTB429CA10,
        page: this.pageMo,
        limit: this.limitMo,
        TXLX: this.txlx, //提现类型:YF 、 YE
        startTime: this.date[0],
        endTime: this.date[1],
      }

      this.tableData = []
      const url = '/orm/ormtb431/selectPageList'
      this.axios
        .post(url, postData)
        .then(res => {
          console.log(res)

          if (res.data.code == 200) {
            var data = res.data.data.list
            this.zjr = res.data.data.sum
            this.tableData = data
            this.pagingPageMo = res.data.count
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
    // 详情
    DetailsClick(row) {
      this.oerderDetilsShow = true
      this.querydetileTX(row)
    },
    isorderAudit(row) {
      this.isorderAuditShow = true
      this.ORMTB421ID = row.ORMTB421ID
      this.querydetileTX(row)
    },
    isorderAuditServe(type) {
      if (type == 2) {
        if (this.isorderAuditText.trim().length == 0)
          return this.$message.error('请填写审核备注')
      }
      // console.log(this.imageUrl)
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var formdata = new FormData()
      formdata.append('ORMTB421CA14', type)
      formdata.append('ORMTB421CA08', this.detailsList.ORMTB421CA08)
      formdata.append('ORMTB421CA02', this.detailsList.ORMTB421CA02)
      formdata.append('ORMTB421CA09', this.detailsList.ORMTB421CA06)
      formdata.append('ORMTB421ID', this.ORMTB421ID)
      formdata.append('ORMTB421CA18', this.isorderAuditText)
      formdata.append('ORMTB421CA21', this.sjtxje)
      formdata.append('ORMTB421CA22', this.sjtxjenotes)
      if (this.imageUrl != '') {
        this.imageUrl.forEach(item => {
          formdata.append('file', item.raw)
        })
      } else {
        formdata.append('file', '')
      }
      this.tableData = []
      if (this.detailsList.ORMTB421CA07 == '司机') {
        var url = '/orm/ormtb421/examine'
      } else {
        var url = '/orm/ormtb421/examineOrmtb410'
      }
      this.axios
        .post(url, formdata, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          // console.log(res)
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '审核成功',
              type: 'success',
            })
            this.isorderAuditShow = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    // 提现详情
    querydetileTX(row) {
      this.detailObj = row
    },
    //获取当前时间
    getNowDay() {
      var date = new Date().getTime()
      var nowDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(date))
      this.date = [nowDay, nowDay]
      this.dateNowDayActive = true
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    datePickerChange(e) {
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    //获取昨天时间
    getYesterday() {
      var hms = new Date().getTime() - 86400000
      var nowDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(hms))
      this.date = [nowDay, nowDay]
      this.dateNowDayActive = false
      this.dateYesterdayActive = true
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    //获取当月时间
    sameMonth() {
      var date = new Date()
      var hms = date.setDate(1)
      var firstDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(hms))
      var nextdate = new Date().getTime()
      var nextDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(nextdate))
      this.date = [firstDay, nextDay]
      this.startTime = this.date[0]
      this.endTime = this.date[1]
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = true
      this.dateLastMonthActive = false
    },
    //获取上月时间
    lastMonth() {
      var nowdays = new Date()
      var year = nowdays.getFullYear()
      var month = nowdays.getMonth()
      if (month == 0) {
        month = 12
        year = year - 1
      }
      if (month < 10) {
        month = '0' + month
      }
      var firstDayOfPreMonth = year + '-' + month + '-' + '01'
      var lastDay = new Date(year, month, 0)
      let lastDayOfPreMonth = year + '-' + month + '-' + lastDay.getDate()
      this.date = [firstDayOfPreMonth, lastDayOfPreMonth]
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = true
    },
    handleSizeChange(val) {
      this.pageMo = 1
      this.limitMo = val
      this.pageList()
    },
    // 点击页码
    handleCurrentChange(val) {
      this.pageMo = val
      this.pageList()
    },
  },
}
</script>

<style scoped>
.performance-records-page {
  position: relative;
  box-sizing: border-box;
  min-height: 100%;
  padding: 16px;
  background:
    radial-gradient(circle at 88% 4%, rgba(43, 132, 210, .14), transparent 28%),
    radial-gradient(circle at 4% 34%, rgba(34, 167, 137, .11), transparent 25%),
    linear-gradient(180deg, #eef5fb 0%, #f7fafc 46%, #f9fbfd 100%);
}

.performance-records-page::before {
  position: absolute;
  inset: 0 0 auto 0;
  height: 112px;
  content: '';
  pointer-events: none;
  background: linear-gradient(180deg, rgba(255, 255, 255, .68), rgba(255, 255, 255, 0));
}

.performance-records-page .performance-filter-panel,
.performance-records-page .performance-table-card {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  border: 1px solid rgba(205, 222, 238, .92);
  border-radius: 20px;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, .98), rgba(247, 251, 255, .95)),
    radial-gradient(circle at 100% 0, rgba(43, 132, 210, .12), transparent 34%);
  box-shadow: 0 16px 36px rgba(31, 72, 110, .09);
}

.performance-records-page .performance-filter-panel {
  display: block;
  padding: 16px;
}

.performance-records-page .performance-filter-head,
.performance-records-page .performance-table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.performance-records-page .performance-filter-head {
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5eef7;
}

.performance-records-page .performance-filter-title,
.performance-records-page .performance-table-title {
  position: relative;
  padding-left: 12px;
  color: #1f3a4a;
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
}

.performance-records-page .performance-filter-title::before,
.performance-records-page .performance-table-title::before {
  position: absolute;
  left: 0;
  top: 5px;
  width: 4px;
  height: 14px;
  content: '';
  border-radius: 4px;
  background: linear-gradient(180deg, #2b84d2, #22a789);
}

.performance-records-page .performance-filter-subtitle,
.performance-records-page .performance-table-subtitle {
  margin-top: 3px;
  padding-left: 12px;
  color: #7b8c98;
  font-size: 12px;
}

.performance-records-page .performance-filter-range {
  padding: 8px 12px;
  border: 1px solid #dfeaf6;
  border-radius: 14px;
  background: #f7fbff;
  color: #607481;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.performance-records-page .performance-filter-body {
  display: grid;
  grid-template-columns: minmax(420px, 1fr) auto;
  align-items: end;
  gap: 14px;
}

.performance-records-page .performance-filter-controls {
  display: grid;
  grid-template-columns: repeat(3, minmax(150px, 1fr));
  gap: 12px;
  min-width: 0;
  margin: 0;
  padding: 0;
}

.performance-records-page .performance-filter-item,
.performance-records-page .performance-phone-filter {
  display: block;
  min-width: 0;
  height: auto;
  margin: 0;
}

.performance-records-page .performance-filter-item .public_lbSty,
.performance-records-page .performance-phone-filter .public_lbSty {
  display: block;
  width: auto;
  height: auto;
  margin: 0 0 7px;
  color: #516674;
  font-size: 13px;
  font-weight: 800;
  line-height: 18px;
}

.performance-records-page .performance-filter-item >>> .el-select,
.performance-records-page .performance-filter-item >>> .el-input,
.performance-records-page .performance-filter-item >>> .el-input__inner,
.performance-records-page .performance-phone-filter >>> .el-input,
.performance-records-page .performance-phone-filter >>> .el-input__inner {
  width: 100% !important;
}

.performance-records-page >>> .el-input__inner,
.performance-records-page >>> .el-date-editor {
  height: 36px;
  line-height: 36px;
  border-color: #dfe8f4;
  border-radius: 10px;
  background: #fff;
}

.performance-records-page .performance-time-controls {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
  margin: 0;
  padding: 0;
}

.performance-records-page .pulic_operatArea_now,
.performance-records-page .public_operatArea_yesterday {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 58px;
  height: 36px;
  padding: 0 14px;
  color: #596a7c;
  border: 1px solid #dfe8f4;
  border-radius: 10px;
  background: #fff;
  font-size: 13px;
  font-weight: 700;
  transition: all .18s ease;
}

.performance-records-page .pulic_operatArea_now:hover,
.performance-records-page .public_operatArea_yesterday:hover {
  color: #2b84d2;
  border-color: rgba(43, 132, 210, .42);
  background: #edf6ff;
}

.performance-records-page .public_dateActive {
  color: #fff !important;
  border-color: transparent !important;
  background: linear-gradient(135deg, #2b84d2, #33a5df) !important;
  box-shadow: 0 8px 16px rgba(43, 132, 210, .22);
}

.performance-records-page .performance-date-picker.el-date-editor--daterange.el-input__inner {
  width: 270px;
}

.performance-records-page .performance-action-controls {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 0;
}

.performance-records-page .performance-action-controls .el-button {
  min-width: 82px;
  height: 36px;
  border: 0;
  border-radius: 10px;
  font-weight: 800;
}

.performance-records-page .performance-action-controls .el-button--primary {
  background: linear-gradient(135deg, #2b84d2, #33a5df) !important;
  box-shadow: 0 8px 18px rgba(43, 132, 210, .22);
}

.performance-records-page .performance-action-controls .el-button--success {
  background: linear-gradient(135deg, #22a789, #28c79c) !important;
  box-shadow: 0 8px 18px rgba(34, 167, 137, .2);
}

.performance-records-page .performance-table-card {
  padding: 16px 16px 0;
}

.performance-records-page .performance-table-head {
  margin-bottom: 14px;
  padding-bottom: 13px;
  border-bottom: 1px solid #e5eef7;
}

.performance-records-page .performance-total-card {
  display: inline-flex;
  align-items: baseline;
  gap: 7px;
  padding: 9px 14px;
  border: 1px solid #dbeaf6;
  border-radius: 15px;
  background:
    linear-gradient(135deg, #f5fbff, #ecf8f4);
  color: #5c7180;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, .9);
}

.performance-records-page .performance-total-card span,
.performance-records-page .performance-total-card em {
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.performance-records-page .performance-total-card strong {
  color: #0f7fc5;
  font-size: 20px;
  font-weight: 900;
}

.performance-records-page .performance-main-table {
  overflow: hidden;
  border: 1px solid #e4edf7;
  border-radius: 14px;
  box-shadow: none;
}

.performance-records-page >>> .performance-main-table .el-table__header th {
  height: 48px;
  border-bottom: 1px solid #dce8f6;
  background: linear-gradient(180deg, #f7fbff, #eaf4fc) !important;
}

.performance-records-page >>> .performance-main-table .el-table__header th .cell {
  color: #2d4658;
  font-size: 15px;
  font-weight: 800;
}

.performance-records-page >>> .performance-main-table .el-table__body-wrapper td {
  height: 56px;
  border-bottom: 1px solid #eef4f9;
  color: #455a64;
  font-size: 13px;
}

.performance-records-page >>> .performance-main-table .el-table__row:hover > td {
  background-color: #f0f9ff !important;
}

.performance-records-page >>> .performance-main-table p {
  margin: 0;
  line-height: 20px;
}

.performance-records-page >>> .performance-main-table .el-button--small {
  min-width: 62px;
  height: 30px;
  padding: 0 12px;
  border: 0;
  border-radius: 9px;
  background: #eef8ff;
  color: #0f7fc5;
  font-weight: 800;
  line-height: 30px;
  box-shadow: none;
}

.performance-records-page .pulbic_pagesize {
  display: flex;
  justify-content: flex-end;
  padding: 14px 2px 16px;
  border: 0;
  background: transparent;
}

.performance-records-page >>> .el-pagination {
  padding: 0;
}

.performance-records-page .DWD-li {
  display: flex;
  min-height: 42px;
  line-height: 1.5;
  box-sizing: border-box;
  border: 1px solid #e1ebf6;
  font-size: 14px;
  color: #33465d;
  background: #fff;
}

.performance-records-page .DWD-li > div {
  display: flex;
  align-items: center;
  min-height: 41px;
  padding: 8px 12px;
  overflow: hidden;
  box-sizing: border-box;
}

.performance-records-page .DWD-li-title {
  justify-content: center;
  width: 150px;
  font-weight: 800;
  color: #2b84d2;
  border-right: 1px solid #e1ebf6;
  background: linear-gradient(135deg, #f4f9ff, #edf6ff);
}

.performance-records-page .DWD-li-text {
  flex: 1;
}

.performance-records-page .DWD-li + .DWD-li {
  border-top: none;
}

.performance-records-page >>> .el-dialog {
  overflow: hidden;
  border-radius: 18px;
}

.performance-records-page >>> .el-dialog__header {
  padding: 18px 22px;
  background: linear-gradient(135deg, #f7fbff, #edf6ff);
}

.performance-records-page >>> .el-dialog__title {
  color: #24364b;
  font-size: 17px;
  font-weight: 800;
}

.performance-records-page >>> .el-dialog__body {
  padding: 22px 24px 26px;
}

.performance-records-page .DetailsWater-Dialog {
  max-height: 68vh;
  margin-bottom: 0 !important;
  overflow-y: auto;
  padding-right: 6px;
}

.performance-records-page th,
.performance-records-page td {
  text-align: center !important;
}

@media screen and (max-width: 1360px) {
  .performance-records-page .performance-filter-body {
    grid-template-columns: 1fr;
  }

  .performance-records-page .performance-time-controls {
    justify-content: flex-start;
  }
}

@media screen and (max-width: 900px) {
  .performance-records-page {
    padding: 12px;
  }

  .performance-records-page .performance-filter-head,
  .performance-records-page .performance-table-head {
    align-items: flex-start;
    flex-direction: column;
  }

  .performance-records-page .performance-filter-controls {
    grid-template-columns: 1fr;
  }

  .performance-records-page .performance-filter-range,
  .performance-records-page .performance-date-picker.el-date-editor--daterange.el-input__inner,
  .performance-records-page .performance-action-controls {
    width: 100%;
  }

  .performance-records-page .performance-action-controls .el-button {
    flex: 1;
  }
}
</style>

<style>
.performance-records-dialog {
  overflow: hidden;
  border-radius: 18px;
}

.performance-records-dialog .el-dialog__header {
  padding: 18px 22px;
  background: linear-gradient(135deg, #f7fbff, #edf6ff);
}

.performance-records-dialog .el-dialog__title {
  color: #24364b;
  font-size: 17px;
  font-weight: 800;
}

.performance-records-dialog .el-dialog__body {
  padding: 22px 24px 26px;
}

.performance-records-dialog .tx-detail-panel {
  padding: 4px 0;
}

.performance-records-dialog .tx-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.performance-records-dialog .tx-detail-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #f4f9ff;
  border: 1px solid #daeaf8;
}

.performance-records-dialog .tx-detail-item--full {
  grid-column: 1 / -1;
  background: linear-gradient(135deg, #fff8ef, #fff3e0);
  border-color: #f5d9a8;
}

.performance-records-dialog .tx-detail-label {
  font-size: 12px;
  font-weight: 600;
  color: #6b8aaa;
  letter-spacing: 0.4px;
}

.performance-records-dialog .tx-detail-value {
  font-size: 16px;
  font-weight: 700;
  color: #0d2a42;
  word-break: break-all;
}

.performance-records-dialog .tx-detail-value--amount {
  font-size: 28px;
  font-weight: 800;
  color: #d4600a;
}
</style>
